<template>
  <div>
    <b-card
      v-for="(item, idx) in model.ChildLogicTrees"
      v-if="model.ChildLogicTrees.length"
      :id="`conditionItem-${idx + 2}`"
      class="mb-2"
    >
      <div class="row justify-content-between">
        <div class="col-4">
          <input-widget
            :id="`rule-${ruleIndex}-condition-${idx + 2}-logical-conjunction`"
            :model="model.ChildLogicTrees[idx]"
            :field="fields.LogicalConjunction"
            :toggle-options="toggleOptions"
          />
        </div>
        <div class="col-4">
          <b-button
            :id="`rule-${ruleIndex}-condition-${idx + 2}-deleteBtn`"
            class="ml-2 float-right"
            size="sm"
            variant="outline-danger"
            @click="onDeleteCondition(idx)"
          >
            <font-awesome-icon :icon="['fas', 'trash']" />
            Delete Condition
          </b-button>
        </div>
      </div>
      <div class="row">
        <div class="col-sm-12">
          <expression-item
            :model="model.ChildLogicTrees[idx]"
            :fields="fields"
            :table-fields="tableFields"
            :rule-index="ruleIndex"
            :condition-index="idx + 2"
          />
        </div>
        <div class="col-sm-12">
          <condition-item
            :model="model.ChildLogicTrees[idx]"
            :fields="fields"
            :table-fields="tableFields"
            :toggle-options="toggleOptions"
          />
        </div>
      </div>
    </b-card>
  </div>
</template>

<script>
import InputWidget from '../../../../../core/components/complex-table/components/InputWidget';
import NoContent from '../../../../../core/components/NoContent';
import ExpressionItem from './ExpressionItem';

export default {
  name: 'ConditionItem',
  components: {
    ExpressionItem,
    NoContent,
    InputWidget,
  },
  props: {
    model: Object,
    fields: Object,
    header: String,
    ruleIndex: {
      type: Number,
      default: 1,
    },
    tableFields: Array,
    toggleOptions: Object,
  },
  methods: {
    onDeleteCondition(index) {
      this.model.ChildLogicTrees.splice(index, 1);
    },
  },
};
</script>

<style scoped>

</style>